import React from 'react'
import styles from './styles.module.scss'
import cn from 'classnames'


const Button = ({children, whiteMode, ...props}) => {
  
  const classNames = cn(styles.button, {[styles.whiteMode]: whiteMode})
  
  return (
    <button className={classNames} {...props}>{children}</button>
  )
}

export default Button